import { ClientBillingInfo } from 'domains/billing';
import { VisitFrequency } from 'domains/care-plans/types';
import { Contact } from 'domains/contact/types';

export type OnboardingStatus =
  | 'requires_evaluation_intake_direct_child' // Needs child intake (evaluation and direct mean nothing now)
  | 'requires_evaluation_intake_direct_adult' // Needs adult intake (evaluation and direct mean nothing now)
  | 'ongoing_sessions'; // Has completed their intake and have unlocked full access to portal (dashboard)

export type BaseClient = {
  clientID: string;
  contactID: string;
  clientFirstName: string;
  clientPreferredName?: string;
  clientLastName: string;
  relationshipToClient: Relationship;
};

export type FullClient = {
  clientID: string;
  clientFirstName: string;
  clientMiddleName: string | null;
  clientLastName: string;
  relationshipToClient: Relationship;
  onboardingStatus: OnboardingStatus;
  careStartDate: string;
  clientPreferredName: string | null;
  sex: string;
  genderIdentity: string | null;
  clientDateOfBirth: string;
  primaryLanguage: string;
  specialtiesRequired: string[];
  state?: string;
  primaryContact: Contact;
  billingInfo: ClientBillingInfo;
  allowMultipleTreatingTherapists: boolean;
  allowReassignment: boolean;
  treatmentAreas?: string[];
  isAtRecommendedVisitFrequency: boolean;
  totalRecurringSessions: number;
  visitFrequency?: VisitFrequency;
  status: 'Active' | 'Inactive';
  /** ISO timestamp of when the treatment consent was granted */
  treatmentConsentGranted?: string;
  careTeam?: {
    clientID: string;
    team: null;
    updatedAt: string;
    createdAt: string;
    createdBy: string;
    reassignmentTimeInHours: number;
    primary: {
      therapistName: string;
      therapistEmail: string;
    };
    allowReassignment: boolean;
  };
};

export type Relationship =
  | 'Parent'
  | 'Client'
  | 'Dependent'
  | 'Family Member'
  | 'Legal Guardian'
  | 'Physician'
  | 'Spouse'
  | 'Other';

export enum ContactRelationship {
  Parent = 'Parent',
  Client = 'Client',
  Dependent = 'Dependent',
  FamilyMember = 'Family Member',
  LegalGuardian = 'Legal Guardian',
  Physician = 'Physician',
  Spouse = 'Spouse',
  Other = 'Other',
}

export enum InsuranceSubscriberRelationship {
  Self = 'Self',
  Child = 'Child',
  Spouse = 'Spouse',
  Other = 'Other',
}

export type LanguageCode =
  | 'en'
  | 'es'
  | 'zh'
  | 'tl'
  | 'vi'
  | 'ar'
  | 'fr'
  | 'ko'
  | 'ru'
  | 'de'
  | 'ht'
  | 'hi'
  | 'pt'
  | 'it'
  | 'pl'
  | 'yi'
  | 'ja'
  | 'fa';

export enum PrimaryLanguageEnum {
  English = 'en',
  Arabic = 'ar',
  Chinese = 'zh',
  French = 'fr',
  German = 'de',
  Korean = 'ko',
  Spanish = 'es',
  Tagalog = 'tl',
  Vietnamese = 'vi',
}
